import keyMirror from 'helpers/keymirror';

const actionTypes = keyMirror({
  FETCH_TRADE_HISTORY_FILTERS: null,
  GET_TRADE_HISTORY_RECORDS: null,
  GET_TRADE_HISTORY_DAILY: null,
});

export default actionTypes;
